import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../node_modules/prop-types/index.js';
import React from 'react';
import TriggerBase$1 from './base/TriggerBase.js';

var _excluded = ["renderTrigger", "renderSubmitting", "renderError"];
/**
 * A helper to submit data from a trigger and display the response
 */

var TriggerBuilder = function TriggerBuilder(props) {
  var renderTrigger = props.renderTrigger,
      renderSubmitting = props.renderSubmitting,
      renderError = props.renderError,
      otherProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(TriggerBase$1, _extends({}, otherProps, {
    render: function render(fireTrigger, state, events) {
      if (state.submitting && renderSubmitting) {
        return renderSubmitting(state.slowSubmitting);
      }

      if (state.error && renderError) {
        return renderError(state.error);
      }

      return renderTrigger(fireTrigger, state, events);
    }
  }));
};

TriggerBuilder.propTypes = {
  renderTrigger: _pt.func.isRequired,
  renderSubmitting: _pt.func,
  renderError: _pt.func,
  submitAction: _pt.func,
  submitParams: _pt.any,
  submitSlowDelay: _pt.number,
  onSubmit: _pt.func,
  onSubmitted: _pt.func,
  abortSubmitOnUnmount: _pt.bool
};
TriggerBuilder.defaultProps = {
  submitSlowDelay: 200,
  abortSubmitOnUnmount: false
};
var TriggerBuilder$1 = TriggerBuilder;

export { TriggerBuilder$1 as default };
